import React from "react";
import "./AboutMe.css";
import url from "./assests/user.jpg";
import file from "./assests/rakib resume.pdf";
const AboutMe = (props) => {
  return (
    <div className="aboutme" id="about">
      <div className="leftSide">
        <div className="picture">
          <img src={url} alt="user pic" />
        </div>
        <div className="download">
          <button>
            <a
              href={file}
              download="rakib resume"
              style={{ textDecoration: "none", color: "black" }}
            >
              Download Resume
            </a>
          </button>
        </div>
      </div>
      <div className="rightSide">
        <div>
          <h2>
            <span style={{ color: "#ffcc00" }}>
              <b>RAKIB SHEIKH</b>
            </span>
          </h2>
        </div>
        <div>
          <h6>Full Stack Web & Blockchain Developer</h6>
        </div>
        <div>
          I am full stack web and Blockchain developer.I have over two year
          experience on that.I am passionated and love to take challenges . 
          I am self-motivated person.
          I have
          solved over 300+ problems in various online judge (like
          uva,lightoj,codeforces)
        </div>
        <br />
        <br />
        <div className="info ">
          <div className="infoLeft">
            <div>Age </div>
            <div>Nationality {} </div>
            <div>Address {}</div>
            <div>Phone {}</div>
            <div>Email {}</div>
          </div>
          <div className="infoRight">
            <div>21</div>
            <div>Bangladeshi</div>
            <div>Rajshahi</div>
            <div>+8801710386886</div>
            <div>rakib.rscse@gmail.com</div>
          </div>
        </div>
        <div className="linkbar">
          <div class="container p-4 pb-0">
            <section class="mb-4">
              <a
                class="btn btn-primary btn-floating m-1"
                // style={"background-color:#3b5998;"}
                style={{ backgroundColor: "#3b5998" }}
                href="https://facebook.com/rakib.rscse"
                role="button"
                target="_blank"
              >
                <i class="fab fa-facebook-f"></i>
              </a>

              <a
                class="btn btn-primary btn-floating m-1"
                style={{ backgroundColor: "#55acee" }}
                href="#!"
                role="button"
              >
                <i class="fab fa-twitter"></i>
              </a>

              <a
                class="btn btn-primary btn-floating m-1"
                style={{ backgroundColor: "#dd4b39" }}
                href="#!"
                role="button"
              >
                <i class="fab fa-google"></i>
              </a>

              <a
                class="btn btn-primary btn-floating m-1"
                style={{ backgroundColor: "#ac2bac" }}
                href="#!"
                role="button"
              >
                <i class="fab fa-instagram"></i>
              </a>

              <a
                class="btn btn-primary btn-floating m-1"
                style={{ backgroundColor: "#0082ca" }}
                href="https://www.linkedin.com/in/rakib-rscse/"
                role="button"
                target="_blank"
              >
                <i class="fab fa-linkedin-in"></i>
              </a>

              <a
                class="btn btn-primary btn-floating m-1"
                style={{ backgroundColor: "#333333" }}
                href="https://github.com/Rakib-RS"
                role="button"
                target="_blank"
              >
                <i class="fab fa-github"></i>
              </a>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
